module.exports = __webpack_public_path__ + "img/mean2.93c500ca.png";